import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-product-info',
    templateUrl: './product-info.component.html',
    styleUrls: ['./product-info.component.scss'],
    standalone: false
})
export class ProductInfoComponent {
  @Input() productInfoTitle = 'Compare Offers';
  @Input() productInfoSection: string;
}
